export const offWhite = '#f7f7f7'
export const lightGrey = '#999999'
export const grey = '#666666'
export const darkGrey = '#333333'
